import type { LucideIcon } from 'lucide-react';
import {
  AlertTriangle,
  Database,
  Home,
  LifeBuoy,
  Layers,
  GitFork,
  History,
  LineChart,
  Loader,
  ShieldCheck,
  Megaphone,
  HandCoins,
  Settings,
  UsersRound,
  Wallet,
  Package,
  Star,
  Store,
  Users,
} from 'lucide-react';

export interface NavItem {
  label: string;
  /** Path under /:sellerId, '' for Home. */
  to: string;
  icon?: LucideIcon;
}

export interface NavGroup {
  /** Shown as a small heading; null for the top-level items. */
  label: string | null;
  items: NavItem[];
}

/**
 * The sidebar, in the order spec S00 gives: Home; Catalog; Market; Campaigns; Deals; Results;
 * Activity; Settings. A screen is listed once it is built, so nothing here is a dead link.
 */
export const NAV_GROUPS: NavGroup[] = [
  { label: null, items: [{ label: 'Home', to: '', icon: Home }] },
  {
    label: 'Catalog',
    items: [
      { label: 'Products', to: 'products', icon: Package },
      { label: 'Product sets', to: 'sets', icon: Layers },
      { label: 'Issues', to: 'issues', icon: AlertTriangle },
      { label: 'Reviews', to: 'reviews', icon: Star },
      { label: 'Data', to: 'data', icon: Database },
    ],
  },
  {
    label: 'Market',
    items: [
      { label: 'Intents', to: 'intents', icon: GitFork },
      { label: 'Prices', to: 'prices', icon: LineChart },
      { label: 'Quality', to: 'quality', icon: Loader },
    ],
  },
  {
    label: 'Campaigns',
    items: [
      { label: 'Campaigns', to: 'campaigns', icon: Megaphone },
      { label: 'Floors', to: 'floors', icon: ShieldCheck },
    ],
  },
  {
    label: 'Deals',
    items: [
      { label: 'Name your price', to: 'deals/name-your-price', icon: HandCoins },
      { label: 'Group buys', to: 'deals/group-buys', icon: UsersRound },
    ],
  },
  {
    label: 'Results',
    items: [
      { label: 'Wallet', to: 'wallet', icon: Wallet },
      { label: 'Activity', to: 'activity', icon: History },
    ],
  },
  { label: null, items: [{ label: 'Settings', to: 'settings', icon: Settings }] },
];

/** Admins only, below the seller's sections and on every admin page: absolute paths. */
export const ADMIN_NAV: NavItem[] = [
  { label: 'Seller support', to: '/admin/sellers', icon: LifeBuoy },
  { label: 'Onboard seller', to: '/admin/sellers/new', icon: Store },
  { label: 'Price comparisons', to: '/admin/prices', icon: LineChart },
  { label: 'People & access', to: '/staff', icon: Users },
];
